import API from "../constants/api";
import axiosInstance, { axiosException } from "./axios";

export const loginRequest = async (email, password) => {
  try {
    const response = await axiosInstance.post(API.LOG_IN, { email, password });
    return {
      success: true,
      data: response.data,
      message: "success",
    };
  } catch (e) {
    return axiosException(e);
  }
};

export const registerRequest = async (payload) => {
  try {
    const response = await axiosInstance.post(API.REGISTER, payload);
    return {
      success: true,
      data: response.data,
      message: "success",
    };
  } catch (e) {
    return axiosException(e);
  }
};

export const forgotPasswordRequest = async (email) => {
  try {
    const response = await axiosInstance.post(API.FORGOT_PASSWORD, {
      email,
    });
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const resetPasswordRequest = async (
  email,
  reset_code,
  new_password,
  confirm_password
) => {
  try {
    const response = await axiosInstance.post(API.RESET_PASSWORD, {
      email,
      reset_code,
      new_password,
      confirm_password,
    });
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getProfileRequest = async () => {
  try {
    const response = await axiosInstance.get(API.PROFILE);
    return response.data.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const updateProfileRequest = async (formData) => {
  try {
    const response = await axiosInstance.post(API.PROFILE, formData, {headers: {'Content-Type': 'multipart/form-data'}});
    return response.data;
  } catch (e) {
    return axiosException(e);
  }
};

export const getRemindersLinks = async (email) => {
  try {
    const response = await axiosInstance.get(
      `${API.SLACK_LINK}?email=${email}`
    );
    return response.data.data;
  } catch (e) {
    return axiosException(e);
  }
};
